import { OptionTypes } from './types';

/**
 * arrayToCSV
 *
 * Joins arrays of strings or numbers to comma separated string representations of themselves
 *
 * @param option A type that needs to be converted to a string, and maybe its an array
 * @returns string value
 */
export const arrayToCSV = (option: OptionTypes): string => {
    if (Array.isArray(option)) {
        return option.join();
    }

    /** Uses string constructor rather than .toString() method for cases like below
     *  String(null);     // "null"
     * value.toString(); // TypeError
     *
     * String constructor will call .toString() on any object that has the method defined.
     * See more https://stackoverflow.com/questions/3945202
     */
    return String(option);
};

/**
 * mapOptionsToStrings
 *
 * API requires query parameters to be string values, this function will return a map of the options object with all
 * values for the keys converted to strings (if necessary)
 *
 * @param options Object containing values to be added to the query string
 * @returns Object with string values
 */
export const mapOptionsToStrings = (
    options: Record<string, OptionTypes | undefined> = {},
): Record<string, string> =>
    Object.entries(options).reduce(
        (obj, [key, value]) =>
            value !== undefined
                ? {
                      [key]: arrayToCSV(value),
                      ...obj,
                  }
                : obj,
        {},
    );
